import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';
import { GeneralResponse } from '../../models/crear-cotizacion/general-response.model';
import { CrearCotizacionRequest } from '../../models/crear-cotizacion/cotizacion.model';
@Injectable({
  providedIn: 'root',
})
export class CotizacionService {
  private baseUrl = `${environment.HOST}${URL_MAP.API.CREARCOTIZACION}`;

  constructor(private http: HttpClient) {}

  private formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  crearCotizacion(
    body: CrearCotizacionRequest,
  ): Observable<GeneralResponse<CrearCotizacionRequest & { idCotizacion?: number }>> {
    return this.http.post<GeneralResponse<CrearCotizacionRequest & { idCotizacion?: number }>>(
      `${this.baseUrl}/cotizacion`,
      body,
    );
  }

  actualizarCotizacion(
    idCotizacion: number,
    body: CrearCotizacionRequest,
  ): Observable<GeneralResponse<CrearCotizacionRequest & { idCotizacion?: number }>> {
    return this.http.put<GeneralResponse<CrearCotizacionRequest & { idCotizacion?: number }>>(
      `${this.baseUrl}/cotizacion/${idCotizacion}`,
      body,
    );
  }

  obtenerCotizacionesConFiltros(filtros: {
    idAsesor?: string;
    fechaDesde?: Date;
    fechaHasta?: Date;
    estado?: string;
    lineaNegocio?: string[];
    idProbabilidadCierre?: number;
    busqueda?: string;
  }): Observable<GeneralResponse<any>> {

    let params = new HttpParams();

    if (filtros.idAsesor) {
      params = params.set('idAsesor', filtros.idAsesor);
    }

    if (filtros.fechaDesde) {
      params = params.set('fechaDesde', this.formatDate(filtros.fechaDesde));
    }

    if (filtros.fechaHasta) {
      params = params.set('fechaHasta', this.formatDate(filtros.fechaHasta));
    }

    if (filtros.estado) {
      params = params.set('estado', filtros.estado);
    }

    if (filtros.lineaNegocio && filtros.lineaNegocio.length) {
      filtros.lineaNegocio.forEach(linea => {
        params = params.append('lineaNegocio', linea);
      });
    }

    if (filtros.idProbabilidadCierre !== undefined && filtros.idProbabilidadCierre !== null) {
      params = params.set('idProbabilidadCierre', filtros.idProbabilidadCierre.toString());
    }

    if (filtros.busqueda) {
      params = params.set('busqueda', filtros.busqueda);
    }

    return this.http.get<GeneralResponse<any>>(
      `${this.baseUrl}/cotizacion`,
      { params }
    );
  }
}
